<app-auth ></app-auth>

@if( isLogged() ){

    <app-side-nav></app-side-nav>
    
}



